import './List.css'

import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { User } from '@/services/repository/users'
import { SearchInput } from '@/components/search/SearchInput'
import { useAppContext } from '@/context/app'
import { Spinner } from '@/components/spinner'

export const DashboardUserTab = ({ }: {}) => {
  const { session, translates, services } = useAppContext()
  const navigate = useNavigate()
  const [filtred, setFiltred] = useState<User[]>()
  const [search, setSearch] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState('')
  const [users, setUsers] = useState<User[]>()

  useEffect(() => {
    var fetchUrl = `/api/communal/statistics/users/list`
    services.session.fetchWithToken(fetchUrl).then(async (r) => {
      if (r.status !== 200) {
        const erros = await r.json()
        console.error(erros)
        return Promise.reject<any>()
      }
      const respUsers: User[] = await r.json()
      setUsers(respUsers)
    })
  }, []);

  useEffect(() => {
    if (!debouncedSearch || debouncedSearch === '') {
      setFiltred(users)
      return
    }
    setFiltred(users?.filter((u) => {
      return u.username.indexOf(debouncedSearch) >= 0
    }))
  }, [users, debouncedSearch])

  if (!translates || !users) {
    return <Spinner />
  }

  return <div className='dashboard-users-tab'>
    <div className='dashboard-users-tab-content'>
      <SearchInput translates={translates} value={search} onChange={setSearch} onDebouncedChange={setDebouncedSearch} />

      <div className='users-list'>
        {filtred?.map(user => (<div className='user' onClick={() => navigate(`/communal/statistics/users?user=${user.username}`)}>
          {user.username}
        </div>))}

        {filtred?.length === 0 ?
          <div className="empty-search-table-message">
            {translates.for("elements.search.empty_table")}
          </div> : null}
      </div>
    </div>
  </div>
}

